import * as React from 'react';
export const qrCodeSvg = React.forwardRef(function qrCodeSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.75 0a.75.75 0 0 0 0 1.5h2.5c.69 0 1.25.56 1.25 1.25v2.5a.75.75 0 0 0 1.5 0v-2.5A2.75 2.75 0 0 0 13.25 0h-2.5ZM4.5 4a.5.5 0 0 0-.5.5V6a.5.5 0 0 0 .5.5H6a.5.5 0 0 0 .5-.5V4.5A.5.5 0 0 0 6 4H4.5Zm0 5.5a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 .5.5H6a.5.5 0 0 0 .5-.5V10a.5.5 0 0 0-.5-.5H4.5Zm5-5A.5.5 0 0 1 10 4h1.5a.5.5 0 0 1 .5.5V6a.5.5 0 0 1-.5.5H10a.5.5 0 0 1-.5-.5V4.5Zm.5 5a.5.5 0 0 0-.5.5v1.5a.5.5 0 0 0 .5.5h1.5a.5.5 0 0 0 .5-.5V10a.5.5 0 0 0-.5-.5H10ZM6.75 7.25a.5.5 0 0 1 .5-.5h1.5a.5.5 0 0 1 .5.5v1.5a.5.5 0 0 1-.5.5h-1.5a.5.5 0 0 1-.5-.5v-1.5Zm4 8.75h2.5A2.75 2.75 0 0 0 16 13.25v-2.5a.75.75 0 0 0-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25h-2.5a.75.75 0 0 0 0 1.5Zm-10-6a.75.75 0 0 1 .75.75v2.5c0 .69.56 1.25 1.25 1.25h2.5a.75.75 0 0 1 0 1.5h-2.5A2.75 2.75 0 0 1 0 13.25v-2.5A.75.75 0 0 1 .75 10Zm4.5-10h-2.5A2.75 2.75 0 0 0 0 2.75v2.5a.75.75 0 0 0 1.5 0v-2.5c0-.69.56-1.25 1.25-1.25h2.5a.75.75 0 0 0 0-1.5Z',
    }),
  );
});
qrCodeSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var qrCode = {
  category: 'icon',
  colorable: true,
  name: 'qrCode',
  svg: qrCodeSvg,
};
